// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"HafBMWAFNgx8J-UP_9GK-","messageArea":"_12aa2SBIS6mOeHi3Awgd4f","button":"_3RVUSzU3XH2qUS19mRQSn3","buttonDarkTheme":"_2j64Ed8l_GoVelOEcRpcn2","MessageAreaDarkTheme":"_iOcQWty6A5dTgXNiuM5T"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/chat/chat-messages/new-message/NewMessage.css
// module id = 262
// module chunks = 0